import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';
import React from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { handleError } from '../../../../shared/functions/handleError';
import { ITeamContributions } from '../../../../shared/interfaces/team-contributions/ITeamContributions';
import { AdminTeamContributionsService } from '../service';
import TeamContributionsForm from './TeamContributionsForm';

export const teamContributionsSchema = yup.object().shape({
  name: yup.string().required('validation.required'),
  userIds: yup.array().of(yup.number()).required('validation.required'),
  isFinished: yup.boolean(),
  price: yup.number().required('validation.required'),
});

const TeamContributionsCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSubmit, control, watch } = useForm<ITeamContributions>({
    resolver: yupResolver(
      teamContributionsSchema,
    ) as unknown as Resolver<ITeamContributions>,
    defaultValues: {
      isFinished: false,
    },
  });

  const submitHandler = (formData: ITeamContributions) => {
    AdminTeamContributionsService.create(formData)
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t('toasts.successfullyCreated', { title: formData?.name }),
            {
              variant: 'success',
            },
          );
        }
      })
      .catch(handleError);
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <TeamContributionsForm control={control} watch={watch} />
    </form>
  );
};

export default TeamContributionsCreate;
